import {get as _get} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';

import {CircularProgress, Backdrop} from '@ui';
import {convertToInt} from '@utils/helpers';
import useQueryCustom from '@utils/hooks/useQueryCustom';
import {GetEventRedirectByDistribution} from '@graphql/event/query';

import {EventRedirect} from './EventRedirect';

export function EventRedirectByDistribution({
    history,
    match,
}) {
    const {
        data: {
            eventRedirectByDistribution,
        } = {},
        error,
        loading: isDataLoading = true,
    } = useQueryCustom({
        query: GetEventRedirectByDistribution,
        options: {
            variables: {
                id: convertToInt(match.params.id),
            },
        },
    });

    return (isDataLoading && !error)
        ? (
            <Backdrop open inverted>
                <CircularProgress />
            </Backdrop>
        )
        : (
            <EventRedirect
                errorMessage='distribution'
                eventContentId={_get(eventRedirectByDistribution, 'event_content_id', null)}
                eventId={_get(eventRedirectByDistribution, 'event_id', null)}
                history={history}
            />
        );
}

EventRedirectByDistribution.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }),
};

export default withRouter(EventRedirectByDistribution);
